export const auConfig = {
    taxOfficeName: 'ATO'
};
